import { ROUTES_NAMES } from '@/constants';
import { beforeEnterLogoutFederatedRoute } from './logoutFederatedNavigationGuards';
import { RouteRecordRaw } from 'vue-router';
import Logout from '@/views/Logout.vue';

const logoutFederatedRoute: RouteRecordRaw = {
  path: '/logout/federated',
  name: ROUTES_NAMES.federatedLogout,
  component: Logout,
  beforeEnter: beforeEnterLogoutFederatedRoute
};

export default logoutFederatedRoute;
